var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkiFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:ski"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.0166 16.5644C21.7203 16.517 20.5825 16.1851 20.2862 16.0547L17.8329 23.7347L14.1707 22.3955L16.7781 15.557L13.1633 11.4444L16.1855 9.714C16.7188 11.0533 17.5721 12.1792 18.6981 13.1036C19.824 14.0281 21.1158 14.6088 22.5618 14.834L23.8892 10.7688L22.1825 10.2118L21.5662 12.1081C20.784 11.7762 20.0966 11.2784 19.504 10.6384C18.9114 9.98659 18.4847 9.22808 18.224 8.37474L17.8329 7.09474C17.6907 6.62067 17.4181 6.24141 17.027 5.95696C16.6358 5.68437 16.1855 5.51845 15.747 5.48289C15.2847 5.44734 14.8344 5.51845 14.4077 5.76734L10.2595 8.16141C9.82103 8.4103 9.50103 8.76585 9.29955 9.21622C9.07436 9.66659 9.02696 10.117 9.07436 10.6029C9.12177 11.0888 9.38251 11.5155 9.71436 11.8829L13.9455 16.2799L11.9425 21.5659L3.70547 18.6147L3.14844 20.2859L19.7884 26.354C21.4363 26.9286 23.2165 27.0069 24.9084 26.5792C25.6077 26.3896 26.2595 26.1288 26.8521 25.797L25.5129 24.4814C24.624 24.8725 23.6995 25.074 22.7395 25.074C21.9573 25.074 21.1751 24.9436 20.3929 24.6829L19.504 24.351L22.0166 16.5644ZM23.2966 4.33326C23.2966 5.64882 22.2418 6.70363 20.9262 6.70363C19.6107 6.70363 18.5558 5.64882 18.5558 4.33326C18.5558 3.01771 19.6225 1.96289 20.9262 1.96289C22.2299 1.96289 23.2966 3.02956 23.2966 4.33326Z",
    fill: "#2D5638"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkiFilter);
export default __webpack_public_path__ + "static/media/ski_filter.9daba46d733aa02b477af34fb956bc54.svg";
export { ForwardRef as ReactComponent };